import React from "react";
import {
  Button,
  Container,
  IconButton,
  InputBase,
  Typography,
} from "@material-ui/core";

import {
  Facebook,
  Twitter,
  Pinterest,
  YouTube,
} from "@material-ui/icons";

const Footer: React.FC = () => {
  const handleSubscribe = () => {
    // Add newsletter API call here
    console.log("Newsletter subscribed");
  };

  return (
    <footer className="organic-footer">

      {/* =====================================================
          NEWSLETTER
      ===================================================== */}

      <div className="footer-newsletter">
        <Container maxWidth="lg">

          <div className="newsletter-content">

            <Typography className="newsletter-eyebrow">
              GET DISCOUNT
            </Typography>

            <Typography className="newsletter-title">
              Subscribe to our Newsletter
            </Typography>

            <div className="newsletter-form">

              <InputBase
                className="newsletter-input"
                placeholder="Please Insert Your Email Address"
                type="email"
              />

              <Button
                className="newsletter-button"
                onClick={handleSubscribe}
              >
                SUBSCRIBE
              </Button>

            </div>

          </div>

        </Container>
      </div>

      {/* =====================================================
          FOOTER CONTENT
      ===================================================== */}

      <Container maxWidth="lg">

        <div className="footer-content">

          {/* =================================================
              BRAND
          ================================================= */}

          <div className="footer-brand-column">

            <div className="footer-brand">

              <div className="footer-brand-icon">
                <span className="footer-shop-icon">
                  ♜
                </span>
              </div>

              <div className="footer-brand-name">
                <span>Shop</span>
                <strong>Organic</strong>
              </div>

            </div>

            <Typography className="footer-description">
              wonderful serenity has taken possession of entire
              soul, like these sweet mornings of spring which
              enjoy with my whole heart. wonderful serenity has
              taken wonderful serenity has taken possession of
              entire soul.
            </Typography>

            {/* Social icons */}

            <div className="footer-socials">

              <IconButton className="footer-social">
                <Facebook />
              </IconButton>

              <IconButton className="footer-social">
                <Twitter />
              </IconButton>

              <IconButton className="footer-social">
                <Pinterest />
              </IconButton>

              <IconButton className="footer-social">
                <YouTube />
              </IconButton>

            </div>

          </div>

          {/* =================================================
              CATEGORY
          ================================================= */}

          <div className="footer-category-column">

            <Typography className="footer-heading">
              Category
            </Typography>

            <div className="category-columns">

              <div className="category-list">

                <a href="#">Vegetables</a>
                <a href="#">Fruits</a>
                <a href="#">Meat</a>
                <a href="#">Canned Organic</a>
                <a href="#">Organic</a>
                <a href="#">Mushrooms</a>
                <a href="#">Organic Juice</a>

              </div>

              <div className="category-list">

                <a href="#">Fresh Onion</a>
                <a href="#">Oatmeal</a>

              </div>

            </div>

          </div>

          {/* =================================================
              CONTACT
          ================================================= */}

          <div className="footer-contact-column">

            <Typography className="footer-heading">
              Contact
            </Typography>

            <Typography className="footer-phone">
              +123 4567 890
            </Typography>

            <Typography className="footer-address">
              <strong>
                Patricia C. Amedee 41 Waldeck Grapevine
              </strong>
              <br />
              Nashville, TX 76
            </Typography>

            <Typography className="footer-email">
              info@yourdomain.com
            </Typography>

          </div>

        </div>

        {/* =====================================================
            BOTTOM
        ===================================================== */}

        <div className="footer-bottom">

          <Typography>
            © {new Date().getFullYear()} ORGANIC SHOP -
            PHLOX ELEMENTOR WORDPRESS THEME.
          </Typography>

        </div>

      </Container>

    </footer>
  );
};

export default Footer;